export const iconFontAwesomeMapsEyeSlash = (
	<i className="fa-solid fa-eye-slash"></i>
);
